export default class NavHover {
  constructor() {
    this.navLine = document.querySelector(".js-nav-line");
    this.navItems = document.querySelectorAll(".c-nav__item");

    this.enterItem = this.enterItem.bind(this);
  }

  init() {
    this.events();
  }

  events() {
    this.clearNavLine();
    this.navItems.forEach(el => {
      el.addEventListener("mouseenter", this.enterItem);
      el.addEventListener("mouseleave", this.leaveItem);
      if (el.firstChild.href === window.location.href) {
        let id = el.dataset.index;
        this.toggleNavLine(id);
      }
      // if (link.href === location.href) {
      //   link.parentNode.classList.add("is-active");
      // }
      // if (el.childNodes.contains("current-menu-item")) {
      //   let id = el.dataset.index;
      //   this.toggleNavLine(id);
      // }
    });
  }

  enterItem(e) {
    let id = e.target.dataset.index;
    this.toggleNavLine(id);
  }

  leaveItem(e) {
    //
  }

  toggleNavLine(id) {
    this.clearNavLine();
    this.navLine.classList.toggle("--item-" + id);
  }

  clearNavLine() {
    this.navLine.classList.remove("--item-1", "--item-2", "--item-3");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/navHover.js